import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, Chapter } from "./shared";

export const Beliefs = () => (
  <section id="beliefs" className="relative py-16 sm:py-24 bg-[#0B0B0C] overflow-hidden" data-testid="beliefs-section">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{ background: "radial-gradient(ellipse 50% 45% at 75% 25%, rgba(255,77,10,0.08), transparent 70%)" }}
    />
    <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <Chapter label="The science" />
      </Reveal>
      <Reveal>
        <h2 className="h-heavy text-[32px] sm:text-5xl lg:text-6xl leading-[0.95] max-w-4xl" data-testid="beliefs-headline">
          You are not{"\u00A0"}moody.
          <br />
          <span className="text-[#FF4D0A]">You are on a clock.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mt-8 text-[#9DA1A8] leading-relaxed max-w-2xl" data-testid="beliefs-body">
          Your cells keep 24 hour time, and there is a Nobel Prize to prove it.
          Light, cortisol and melatonin decide how your day feels long before
          your calendar does. We unpacked the record, study by study.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="mt-10">
          <Link
            to="/science"
            className="inline-flex items-center justify-center gap-2 border border-[#FF4D0A] text-[#FF4D0A] hover:bg-[#FF4D0A] hover:text-[#0B0B0C] transition-colors px-7 sm:px-9 py-4 font-mono-brand text-[11px] sm:text-xs font-bold tracking-[2px] uppercase"
            data-testid="beliefs-science-link"
          >
            Read the science
            <ArrowUpRight size={14} strokeWidth={2.5} />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
